var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"points-btn"},[_c('points-icon'),(_vm.points > 0)?_c('span',[_vm._v(_vm._s(_vm.points))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }